import React, { useState, useEffect } from 'react';
import BasicCard from '../../components/basics/cards/BasicCard'
import DataTable from '../../components/data-table/DataTable';
import BasicAddEditHelpers from '../../components/basics/tabs/add-edit/utils/BasicAddEditHelpers';
import './basicReport.css'
import { CommonAPIService } from "../../services/apis/CommonAPIService";
import { ErrorService } from '../../services/ErrorService';

function BasicReportTable({ filterArray, pageConfig, downloadOptions, tableConfig, setUpdatingFilter, usePagination }) {
    const basicAddEditHelpers = new BasicAddEditHelpers()
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const {apiName, controllerName, pageSettings } = pageConfig    
    const [error, setError] = useState("");
   
    useEffect(() => {
        setIsLoading(true);
        setData([]);
        if (Array.isArray(filterArray)) {
            setUpdatingFilter(true);
            const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
            // fetch data from API
            CommonAPIService.callApiUsingUrl(`${apiName}${controllerName}/Data?filterArray=${filterArrayString}`)
                .then(response => {
                    if (response.error)
                        setError(ErrorService.getErrorMessage(data.error.status))
                    else {
                        setUpdatingFilter(false)   
                        setError(false)
                        setData(response);
                        setIsLoading(false);
                    }
                })
        }       
    }, [apiName, controllerName, filterArray]);

    //if (!isLoading)
    //    const columns = data.length > 0 ? Object.keys(data[0]) : [];

    return (
        <BasicCard cardConfig={{ cardTitle: pageSettings ? pageSettings.name : '...', cardHeadingElement: 'h5' }}>
            {isLoading ? <p>Loading data ...</p> : ""}
            {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
            {!isLoading &&
                <div className='listing-table-wrapper'>
                    <DataTable
                        tableConfig={basicAddEditHelpers.createTableConfigDataResonseModel(data)}
                        usePagination={usePagination}
                    />
                </div>
            }
        </BasicCard>
    );
}

export default BasicReportTable;
